import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    props: {
        spaces: {
            type: Array,
            default: () => []
        }
    }
});
